import { immer } from "zustand/middleware/immer";

import { FavoritesRequest, FavoritesViewType } from "@/types";
import { createStore } from "@/utils";

type TabState = {
  request: FavoritesRequest;
  viewType: FavoritesViewType;
  meta: {
    currentIndex: number;
    currentPage: number;
  };
};

export type FavoritesState = {
  liked: TabState;
  "liked-me": TabState;
  "viewed-me": TabState;
};

type FavoritesActions = {
  actions: {
    liked: {
      changeRequest: (data: FavoritesRequest) => void;
      changeViewType: (viewType: FavoritesViewType) => void;
      changeMeta: (data: Partial<FavoritesState["liked"]["meta"]>) => void;
    };
    "liked-me": {
      changeRequest: (data: FavoritesRequest) => void;
      changeViewType: (viewType: FavoritesViewType) => void;
      changeMeta: (data: Partial<FavoritesState["liked-me"]["meta"]>) => void;
    };
    "viewed-me": {
      changeRequest: (data: FavoritesRequest) => void;
      changeViewType: (viewType: FavoritesViewType) => void;
      changeMeta: (data: Partial<FavoritesState["viewed-me"]["meta"]>) => void;
    };
  };
};

const defaultFavoritesValues: FavoritesState = {
  liked: {
    viewType: "column",
    request: {
      sortBy: "createdAt",
    },
    meta: {
      currentIndex: 0,
      currentPage: 1,
    },
  },
  "liked-me": {
    viewType: "column",
    request: {
      sortBy: "createdAt",
    },
    meta: {
      currentIndex: 0,
      currentPage: 1,
    },
  },
  "viewed-me": {
    viewType: "column",
    request: {
      sortBy: "createdAt",
    },
    meta: {
      currentIndex: 0,
      currentPage: 1,
    },
  },
};

const useFavoritesStore = createStore<FavoritesState & FavoritesActions>(
  immer((set) => ({
    ...defaultFavoritesValues,
    actions: {
      liked: {
        changeRequest: (data) =>
          set((state) => {
            state.liked.request = { ...state.liked.request, ...data };
          }),
        changeViewType: (viewType) =>
          set((state) => {
            state.liked.viewType = viewType;
          }),
        changeMeta: (meta) =>
          set((state) => {
            state.liked.meta = { ...state.liked.meta, ...meta };
          }),
      },
      "liked-me": {
        changeRequest: (data) =>
          set((state) => {
            state["liked-me"].request = { ...state["liked-me"].request, ...data };
          }),
        changeViewType: (viewType) =>
          set((state) => {
            state["liked-me"].viewType = viewType;
          }),
        changeMeta: (meta) =>
          set((state) => {
            state["liked-me"].meta = { ...state["liked-me"].meta, ...meta };
          }),
      },
      "viewed-me": {
        changeRequest: (data) =>
          set((state) => {
            state["viewed-me"].request = { ...state["viewed-me"].request, ...data };
          }),
        changeViewType: (viewType) =>
          set((state) => {
            state["viewed-me"].viewType = viewType;
          }),
        changeMeta: (meta) =>
          set((state) => {
            state["viewed-me"].meta = { ...state["viewed-me"].meta, ...meta };
          }),
      },
    },
  }))
);

export { useFavoritesStore };
